import { styled } from "@mui/material";
import { PickersLayout } from "@mui/x-date-pickers-pro";
import { Theme } from "@mui/material";

/**
 * Provides custom styles for the DatePickerLayout component.
 * It uses ThemeProvider2024 theme to ensure consistency with the application's design system.
 */
export const datePickerLayoutStyles = ({ theme }: { theme: Theme }) => {
  return {
    "& .MuiYearCalendar-button": {
      fontSize: theme.typography.TextM.fontSize,
      lineHeight: theme.typography.TextM.lineHeight,
    },

    "& .MuiPickersDay-root": {
      color: theme.palette.primary.main,
      "&.MuiPickersDay-today": {
        fontWeight: theme.typography.fontWeightMedium,
      },
      "& .Mui-disabled": {
        color: theme.palette.grey[100],
      },
    },

    "& .MuiPickersDay-root.Mui-selected": {
      backgroundColor: theme.palette.secondary1[60],
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,

      "&:hover": {
        backgroundColor: theme.palette.secondary1[100],
        color: theme.palette.primary.main,
      },
      "&:focus": {
        backgroundColor: theme.palette.secondary1[60],
        color: theme.palette.primary.main,
      },
    },

    ".Mui-disabled": {
      color: theme.palette.grey[100],
    },

    "& .MuiPickersDay-root:not(.Mui-selected)": {
      border: "none",
      "&:hover, &:focus": {
        backgroundColor: theme.palette.secondary1[10],
      },
    },
  };
};

export const DatePickerLayout = styled(PickersLayout)(datePickerLayoutStyles) as typeof PickersLayout;

export default DatePickerLayout;
